import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../environments/environment";
import {FeedbackDto, MarketResearchQuestionDto, RatingDto} from "admin-api-dto";

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  constructor(private readonly http: HttpClient) {
  }

  getFeedback(): Observable<FeedbackDto[]> {
    return this.http.get<FeedbackDto[]>(`${environment.apiUrl}/api/private/feedback`);
  }

  getRatings(): Observable<RatingDto[]> {
    return this.http.get<RatingDto[]>(`${environment.apiUrl}/api/private/ratings`);
  }

  getMarketResearchQuestions(): Observable<MarketResearchQuestionDto[]> {
    return this.http.get<MarketResearchQuestionDto[]>(`${environment.apiUrl}/api/private/market-research-questions`);
  }

  requestRatingsExport() {
    return this.http.get<{ s3Key: string }>(`${environment.apiUrl}/api/private/ratings/csv`);
  }

  getRatingsDownloadUrl(s3Key: string) {
    return this.http.get<{ url: string }>(`${environment.apiUrl}/api/private/ratings/csv/signed`, {
      params: {s3Key}
    });
  }

  requestMarketResearchQuestionsExport() {
    return this.http.get<{ s3Key: string }>(`${environment.apiUrl}/api/private/market-research-questions/csv`);
  }

  getMarketResearchQuestionsDownloadUrl(s3Key: string) {
    return this.http.get<{ url: string }>(`${environment.apiUrl}/api/private/market-research-questions/csv/signed`, {
      params: {s3Key}
    });
  }
}
